import { EqTypography, EqButton } from "@equitable/equx";
import { Grid } from "@mui/material";
import { SuccessTranslationValues } from "../types";
import thumbsUp from "../assets/thumbs_up.svg";

type SuccessProps = {
  translations: SuccessTranslationValues;
};

const Success = ({ translations }: SuccessProps) => {
  const handleButtonClick = () => {
    window.location.href = translations.ratesUrl;
  };

  return (
    <Grid
      item
      sx={{
        backgroundColor: "#fff",
        margin: "48px 0",
        width: "582px",
        borderRadius: "24px",
        padding: "48px",
        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.16)",
      }}
    >
      <Grid container rowSpacing={4} sx={{ margin: 0 }}>
        <Grid container justifyContent="center">
          <img
            src={thumbsUp}
            alt="thumbs up"
            width="156"
            height="156"
            style={{ margin: "inherit" }}
          />
        </Grid>
        <Grid item xs={12}>
          <EqTypography variant="h3" sx={{ textAlign: "center" }}>
            {translations.msg1}
          </EqTypography>
          <EqTypography variant="h3" sx={{ textAlign: "center" }}>
            {translations.msg2}
          </EqTypography>
        </Grid>
        <Grid item xs={12}>
          <EqTypography
            variant="h6"
            sx={{ textAlign: "center", whiteSpace: "pre-line" }}
          >
            {translations.msg3}
          </EqTypography>
        </Grid>
        <Grid item xs={12}>
          <EqButton
            label={translations.buttonLabel}
            variant="contained"
            leftIcon="ChevronLeft"
            color="surfacePrimaryDark"
            sx={{ width: "100%", padding: "16px", height: "48px" }}
            onClick={handleButtonClick}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Success;
